<div class="sd-element__erbox sd-error sd-question__erbox sd-question__erbox--below-question">
  <div class="sd-question__erbox-message">
    {{ errorMessage }}
  </div>
</div>
